import { HandlebarNumber } from '../HandlebarNumber';
import { HandlebarInt } from '../HandlebarInt';
import { HandlebarFloat } from '../HandlebarFloat';

export const isHandlebarNumber = (value: unknown): value is HandlebarNumber =>
  value instanceof HandlebarFloat || value instanceof HandlebarInt;
